/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Playground, Props } from 'docz'
import Button from './'
import { Intent } from "../../common/intent";
import { Appearance } from "../../common/appearance";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "button"
    }}>{`Button`}</h1>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<Button>Button</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button,
      Intent,
      Appearance
    }} mdxType="Playground">
  <Button mdxType="Button">Button</Button>
    </Playground>
    <h2 {...{
      "id": "appearance"
    }}>{`Appearance`}</h2>
    <Playground __position={1} __code={'<Button appearance={Appearance.MINIMAL}>Minimal Button</Button>\n<Button appearance={Appearance.DEFAULT}>Default Button</Button>\n<Button appearance={Appearance.PROMINENT}>Prominent Button</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button,
      Intent,
      Appearance
    }} mdxType="Playground">
  <Button appearance={Appearance.MINIMAL} mdxType="Button">Minimal Button</Button>
  <Button appearance={Appearance.DEFAULT} mdxType="Button">Default Button</Button>
  <Button appearance={Appearance.PROMINENT} mdxType="Button">Prominent Button</Button>
    </Playground>
    <h2 {...{
      "id": "intent"
    }}>{`Intent`}</h2>
    <Playground __position={2} __code={'<Button intent={Intent.NONE} appearance={Appearance.MINIMAL}>\n  None\n</Button>\n<Button intent={Intent.SUCCESS} appearance={Appearance.MINIMAL}>\n  Success\n</Button>\n<Button intent={Intent.WARNING} appearance={Appearance.MINIMAL}>\n  Warning\n</Button>\n<Button intent={Intent.DANGER} appearance={Appearance.MINIMAL}>\n  Danger\n</Button>\n<br />\n<br />\n<Button intent={Intent.NONE} appearance={Appearance.DEFAULT}>\n  None\n</Button>\n<Button intent={Intent.SUCCESS} appearance={Appearance.DEFAULT}>\n  Success\n</Button>\n<Button intent={Intent.WARNING} appearance={Appearance.DEFAULT}>\n  Warning\n</Button>\n<Button intent={Intent.DANGER} appearance={Appearance.DEFAULT}>\n  Danger\n</Button>\n<br />\n<br />\n<Button intent={Intent.NONE} appearance={Appearance.PROMINENT}>\n  None\n</Button>\n<Button intent={Intent.SUCCESS} appearance={Appearance.PROMINENT}>\n  Success\n</Button>\n<Button intent={Intent.WARNING} appearance={Appearance.PROMINENT}>\n  Warning\n</Button>\n<Button intent={Intent.DANGER} appearance={Appearance.PROMINENT}>\n  Danger\n</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button,
      Intent,
      Appearance
    }} mdxType="Playground">
  <Button intent={Intent.NONE} appearance={Appearance.MINIMAL} mdxType="Button">None</Button>
  <Button intent={Intent.SUCCESS} appearance={Appearance.MINIMAL} mdxType="Button">Success</Button>
  <Button intent={Intent.WARNING} appearance={Appearance.MINIMAL} mdxType="Button">Warning</Button>
  <Button intent={Intent.DANGER} appearance={Appearance.MINIMAL} mdxType="Button">Danger</Button>
  <br /><br />
  <Button intent={Intent.NONE} appearance={Appearance.DEFAULT} mdxType="Button">None</Button>
  <Button intent={Intent.SUCCESS} appearance={Appearance.DEFAULT} mdxType="Button">Success</Button>
  <Button intent={Intent.WARNING} appearance={Appearance.DEFAULT} mdxType="Button">Warning</Button>
  <Button intent={Intent.DANGER} appearance={Appearance.DEFAULT} mdxType="Button">Danger</Button>
  <br /><br />
  <Button intent={Intent.NONE} appearance={Appearance.PROMINENT} mdxType="Button">None</Button>
  <Button intent={Intent.SUCCESS} appearance={Appearance.PROMINENT} mdxType="Button">Success</Button>
  <Button intent={Intent.WARNING} appearance={Appearance.PROMINENT} mdxType="Button">Warning</Button>
  <Button intent={Intent.DANGER} appearance={Appearance.PROMINENT} mdxType="Button">Danger</Button>
    </Playground>
    <h2 {...{
      "id": "icons"
    }}>{`Icons`}</h2>
    <Playground __position={3} __code={'<Button\n  iconBefore=\"edit\"\n  appearance={Appearance.MINIMAL}\n  intent={Intent.NONE}\n>\n  Before\n</Button>\n<Button\n  iconBefore=\"edit\"\n  appearance={Appearance.MINIMAL}\n  intent={Intent.SUCCESS}\n>\n  Before\n</Button>\n<Button\n  iconBefore=\"edit\"\n  appearance={Appearance.MINIMAL}\n  intent={Intent.WARNING}\n>\n  Before\n</Button>\n<Button\n  iconBefore=\"edit\"\n  appearance={Appearance.MINIMAL}\n  intent={Intent.DANGER}\n>\n  Before\n</Button>\n<br />\n<br />\n<Button iconAfter=\"eye\" intent={Intent.NONE}>\n  After\n</Button>\n<Button iconAfter=\"eye\" intent={Intent.SUCCESS}>\n  After\n</Button>\n<Button iconAfter=\"eye\" intent={Intent.WARNING}>\n  After\n</Button>\n<Button iconAfter=\"eye\" intent={Intent.DANGER}>\n  After\n</Button>\n<br />\n<br />\n<Button\n  iconBefore=\"minus\"\n  iconAfter=\"plus\"\n  appearance={Appearance.PROMINENT}\n  intent={Intent.NONE}\n>\n  Both\n</Button>\n<Button\n  iconBefore=\"minus\"\n  iconAfter=\"plus\"\n  appearance={Appearance.PROMINENT}\n  intent={Intent.SUCCESS}\n>\n  Both\n</Button>\n<Button\n  iconBefore=\"minus\"\n  iconAfter=\"plus\"\n  appearance={Appearance.PROMINENT}\n  intent={Intent.WARNING}\n>\n  Both\n</Button>\n<Button\n  iconBefore=\"minus\"\n  iconAfter=\"plus\"\n  appearance={Appearance.PROMINENT}\n  intent={Intent.DANGER}\n>\n  Both\n</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button,
      Intent,
      Appearance
    }} mdxType="Playground">
  <Button iconBefore="edit" appearance={Appearance.MINIMAL} intent={Intent.NONE} mdxType="Button">Before</Button>
  <Button iconBefore="edit" appearance={Appearance.MINIMAL} intent={Intent.SUCCESS} mdxType="Button">Before</Button>
  <Button iconBefore="edit" appearance={Appearance.MINIMAL} intent={Intent.WARNING} mdxType="Button">Before</Button>
  <Button iconBefore="edit" appearance={Appearance.MINIMAL} intent={Intent.DANGER} mdxType="Button">Before</Button>
  <br /><br />
  <Button iconAfter="eye" intent={Intent.NONE} mdxType="Button">After</Button>
  <Button iconAfter="eye" intent={Intent.SUCCESS} mdxType="Button">After</Button>
  <Button iconAfter="eye" intent={Intent.WARNING} mdxType="Button">After</Button>
  <Button iconAfter="eye" intent={Intent.DANGER} mdxType="Button">After</Button>
  <br /><br />
  <Button iconBefore="minus" iconAfter="plus" appearance={Appearance.PROMINENT} intent={Intent.NONE} mdxType="Button">Both</Button>
  <Button iconBefore="minus" iconAfter="plus" appearance={Appearance.PROMINENT} intent={Intent.SUCCESS} mdxType="Button">Both</Button>
  <Button iconBefore="minus" iconAfter="plus" appearance={Appearance.PROMINENT} intent={Intent.WARNING} mdxType="Button">Both</Button>
  <Button iconBefore="minus" iconAfter="plus" appearance={Appearance.PROMINENT} intent={Intent.DANGER} mdxType="Button">Both</Button>
    </Playground>
    <h2 {...{
      "id": "disabled"
    }}>{`Disabled`}</h2>
    <Playground __position={4} __code={'<Button disabled appearance={Appearance.MINIMAL}>\n  Minimal\n</Button>\n<Button disabled appearance={Appearance.DEFAULT}>\n  Default\n</Button>\n<Button disabled appearance={Appearance.PROMINENT}>\n  Prominent\n</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button,
      Intent,
      Appearance
    }} mdxType="Playground">
  <Button disabled appearance={Appearance.MINIMAL} mdxType="Button">Minimal</Button>
  <Button disabled appearance={Appearance.DEFAULT} mdxType="Button">Default</Button>
  <Button disabled appearance={Appearance.PROMINENT} mdxType="Button">Prominent</Button>
    </Playground>
    <h2 {...{
      "id": "loading"
    }}>{`Loading`}</h2>
    <Playground __position={5} __code={'<Button isLoading appearance={Appearance.MINIMAL}>\n  Minimal\n</Button>\n<Button isLoading appearance={Appearance.DEFAULT}>\n  Default\n</Button>\n<Button isLoading appearance={Appearance.PROMINENT}>\n  Prominent\n</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button,
      Intent,
      Appearance
    }} mdxType="Playground">
  <Button isLoading appearance={Appearance.MINIMAL} mdxType="Button">Minimal</Button>
  <Button isLoading appearance={Appearance.DEFAULT} mdxType="Button">Default</Button>
  <Button isLoading appearance={Appearance.PROMINENT} mdxType="Button">Prominent</Button>
    </Playground>
    <h2 {...{
      "id": "block"
    }}>{`Block`}</h2>
    <Playground __position={6} __code={'<Button block>Block button</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button,
      Intent,
      Appearance
    }} mdxType="Playground">
  <Button block mdxType="Button">Block button</Button>
    </Playground>
    <h3 {...{
      "id": "proptypes"
    }}>{`PropTypes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Text props`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "/typography/text"
            }}>{`Text`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`borderRadius`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`base`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`intent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`enum`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`NONE`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "/common/intent"
            }}>{`Intent`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`appearance`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`enum`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`DEFAULT`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "/common/appearance"
            }}>{`Appearance`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`block`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`disabled`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`iconBefore`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`iconAfter`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isLoading`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  